var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Formik } from 'formik';
import isNil from 'lodash/isNil';
// Inspired by https://sage.amazon.com/questions/585958#607688
class PolarisFormik extends React.Component {
    constructor() {
        super(...arguments);
        this.handleBlur = (setFieldValue, setFieldTouched) => e => {
            if (e && e.target && e.detail) {
                // Selects do not have a name property. Neither do radio groups :(
                const name = e.target.component.__properties.name ||
                    e.target.component.__properties.controlId ||
                    e.target.id;
                // Selects use selectedId, checkboxes use checked
                const value = e.detail.value || e.detail.selectedId || e.detail.checked;
                setFieldValue(name, value);
                setFieldTouched(name);
            }
            else if (e && e.target && e.target.files) {
                // Support raw file input, as there is no Polaris component yet
                const name = e.target.name;
                setFieldValue(name, e.target.files);
                setFieldTouched(name);
            }
        };
        this.handleChange = setFieldValue => e => {
            if (e && e.target && e.detail) {
                // Selects do not have a name property. Neither do radio groups :(
                const name = e.target.component.__properties.name ||
                    e.target.component.__properties.controlId ||
                    e.target.id;
                // Selects use selectedId, checkboxes use checked.  Unfortunately,
                // using coalescing with || does not work, because it swallows 0's
                // and empty strings.
                let value = e.detail.value;
                if (isNil(value)) {
                    value = e.detail.selectedIds; // Support multi-select, which has both selectedId and selectedIds in its change event
                    if (isNil(value)) {
                        value = e.detail.selectedId;
                        if (isNil(value)) {
                            value = e.detail.checked;
                        }
                    }
                }
                setFieldValue(name, value);
            }
            else if (e && e.target && e.target.files) {
                // Support raw file input, as there is no Polaris component yet
                const name = e.target.name;
                setFieldValue(name, e.target.files);
            }
        };
        this.renderForm = (_a) => {
            var { setFieldValue, setFieldTouched } = _a, props = __rest(_a, ["setFieldValue", "setFieldTouched"]);
            const { render } = this.props;
            return (render &&
                render(Object.assign({}, props, { setFieldValue,
                    setFieldTouched, handleChange: this.handleChange(setFieldValue), handleBlur: this.handleBlur(setFieldValue, setFieldTouched) })));
        };
    }
    render() {
        return React.createElement(Formik, Object.assign({}, this.props, { render: this.renderForm }));
    }
}
export default PolarisFormik;
//# sourceMappingURL=PolarisFormik.js.map